import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';

import Home from './pages/Home';
import SignUp from './pages/SignUp';
import LogIn from './pages/LogIn';
import Authorize from './pages/Authorize';
import Account from './pages/Account';
import CreateRace from './pages/CreateRace';
import Race from './pages/Race';
import Rider from './pages/Rider';
import CreateTrophy from './pages/CreateTrophy';
import Trophy from './pages/Trophy';
import CreateClub from './pages/CreateClub';
import Club from './pages/Club';
import Clubs from './pages/Clubs';
import Leaderboard from './pages/Leaderboard';
import SendEmail from './pages/SendEmail';

Vue.use(Router);
Vue.use(VueResource);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn
    },
    {
      path: '/authorize',
      name: 'Authorize',
      component: Authorize
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/create-race',
      name: 'CreateRace',
      component: CreateRace,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/race/:id',
      name: 'Race',
      component: Race,
      props: true
    },
    {
      path: '/rider/:id',
      name: 'Rider',
      component: Rider,
      props: true
    },
    {
      path: '/create-trophy/:id',
      name: 'CreateTrophy',
      component: CreateTrophy,
      meta: {
        requiresAuth: true,
      },
      props: true
    },
    {
      path: '/trophy/:id',
      name: 'Trophy',
      component: Trophy,
      props: true
    },
    {
      path: '/create-club',
      name: 'CreateClub',
      component: CreateClub,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/club/:id',
      name: 'Club',
      component: Club,
      props: true
    },
    {
      path: '/clubs',
      name: 'Clubs',
      component: Clubs
    },
    {
      path: '/leaderboard',
      name: 'Leaderboard',
      component: Leaderboard
    },
    {
      path: '/send-email/:id',
      name: 'SendEmail',
      component: SendEmail,
      meta: {
        requiresAuth: true,
      },
      props: true
    },
  ],
});

export default router;